module.exports = __webpack_public_path__ + "static/media/pdf-icon.b1fe786a.png";